import { render, staticRenderFns } from "./ReceivingInfo.vue?vue&type=template&id=8f3ac442&scoped=true"
import script from "./ReceivingInfo.vue?vue&type=script&lang=js"
export * from "./ReceivingInfo.vue?vue&type=script&lang=js"
import style0 from "./ReceivingInfo.vue?vue&type=style&index=0&id=8f3ac442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3ac442",
  null
  
)

export default component.exports